import { __decorate, __metadata, __param } from "tslib";
import { Directive, Inject } from 'angular-ts-decorators';
var AutoFocusDirective = (function () {
    function AutoFocusDirective($element) {
        this.$element = $element;
    }
    AutoFocusDirective.prototype.ngOnInit = function () {
        this.$element.focus();
    };
    AutoFocusDirective.$inject = ['$element'];
    AutoFocusDirective = __decorate([
        Directive({
            selector: '[autoFocus]',
        }),
        __param(0, Inject('$element')),
        __metadata("design:paramtypes", [Object])
    ], AutoFocusDirective);
    return AutoFocusDirective;
}());
export { AutoFocusDirective };
